import { UserPlus, Star } from 'lucide-react';

const creators = [
  {
    id: 'sugg-001',
    name: 'Kwame Asante',
    handle: '@kwame.infra',
    initials: 'KA',
    gradient: 'from-cyan-500 to-blue-500',
    role: 'Infrastructure Engineer',
    followers: '22.1K',
    verified: false,
    reason: 'Followed by 14 people you follow',
    matchScore: 91,
  },
  {
    id: 'sugg-002',
    name: 'Naledi Dlamini',
    handle: '@naledi.dev',
    initials: 'ND',
    gradient: 'from-purple-500 to-violet-500',
    role: 'Full-stack Developer',
    followers: '8.4K',
    verified: false,
    reason: 'Active in #security and #supabase',
    matchScore: 87,
  },
  {
    id: 'sugg-003',
    name: 'Aisha Mensah',
    handle: '@aisha.product',
    initials: 'AM',
    gradient: 'from-blue-500 to-indigo-500',
    role: 'Product Manager',
    followers: '31.2K',
    verified: true,
    reason: 'Trending in #product-thinking',
    matchScore: 84,
  },
];

export default function SuggestedCreators() {
  return (
    <div className="card-elevated p-4">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <UserPlus size={14} className="text-accent" />
          <span className="text-sm font-600 text-foreground">Suggested Creators</span>
        </div>
        <span className="text-xs text-muted-foreground">Intent-matched</span>
      </div>

      <div className="space-y-3">
        {creators?.map((creator) => (
          <div key={creator?.id} className="flex items-start gap-3 group">
            <div className={`w-9 h-9 rounded-full bg-gradient-to-br ${creator?.gradient} flex items-center justify-center text-white text-xs font-700 flex-shrink-0`}>
              {creator?.initials}
            </div>

            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-1">
                <span className="text-sm font-600 text-foreground truncate">{creator?.name}</span>
                {creator?.verified && <Star size={11} className="text-accent fill-accent flex-shrink-0" />}
              </div>
              <div className="text-xs text-muted-foreground truncate">{creator?.handle}</div>
              <div className="text-xs text-muted-foreground/70 mt-0.5 truncate">{creator?.reason}</div>
            </div>

            <button className="flex-shrink-0 px-2.5 py-1 rounded-lg border border-border text-xs font-600 text-foreground hover:border-primary/40 hover:bg-primary/10 hover:text-accent transition-all duration-150">
              Follow
            </button>
          </div>
        ))}
      </div>

      <button className="w-full mt-3 text-xs text-accent hover:underline text-center py-1">
        Discover more creators
      </button>
    </div>
  );
}